import fastInitializeComponent from 'Shared/fast-react-initialize';
import ImageComponent from './image_component';
fastInitializeComponent('ImageComponent', ImageComponent);
